<template lang="pug">
EcreativArchetypesHeading(tag="h2" size="3") Latest Articles
.articlesGrid.d-grid.mb-5.row-gap-4.column-gap-4(v-if="articles.length")
  .item(v-for='item in articles', :key='item.id')
    EcreativMoleculesCardsArticleCard(
      :id='item.id',
      :key='item.id',
      :image='item.image',
      :title='item.title',
      :content="''",
      :truncateContent="''",
      :link='item.slug',
      linkLabel="Read More",
      category='articles',
      :date='item.date'
    )
div(v-else)
  p There are no articles yet.
EcreativMoleculesInteractiveLoadMore.mb-5(
  v-if="!articlesStore.hideLoadMore",
  :isLoading="articlesStore.isLoading"
)
</template>

<script setup>
import EcreativArchetypesHeading from '../archetypes/Heading';
import EcreativMoleculesInteractiveLoadMore from '../molecules/Interactive/LoadMore.vue';
import EcreativMoleculesCardsArticleCard from '../molecules/Cards/ArticleCard.vue';
import { useArticlesStore } from 'data-layer/exports';

const articlesStore = useArticlesStore();

defineProps({
  articles: {
    type: Array,
    required: true,
  },
});
</script>

<style lang="scss" scoped>
.articlesGrid {
  grid-template-columns: auto;

  @include media-breakpoint-up(sm) {
    grid-template-columns: auto auto;
    column-gap: 25px;
  }
}
</style>
